export const DIARY_MENU_ACTIONS = {
    COPY: 'copy',
    MOVE: 'move',
    FAVORITE: 'favorite',
    UNFAVORITE: 'unfavorite',
    EDIT: 'edit',
    NUTRITION: 'nutrition',
    DELETE: 'delete',
    ADD_MEAL_TYPE: 'addMealType'
};

export const ALL_DIARY_MENU_ACTIONS = Object.values(DIARY_MENU_ACTIONS);
